import React, {createContext, useState} from 'react';

const UserVotesContext = createContext({
  initialUserVotes: [],
  setInitialUserVotes: () => {},
  nominationVotes: [],
  setNominationVotes: () => {},
  setCandidates: () => {},
  candidates: []
});

const UserVotesProvider = ({children}) => {
  const [initialUserVotes, setInitialUserVotes] = useState([]);
  const [nominationVotes, setNominationVotes] = useState([]);
  const [candidates, setCandidates] = useState({nominationId: null, list: []});

  return (
    <UserVotesContext.Provider
      value={{
        initialUserVotes,
        setInitialUserVotes,
        nominationVotes,
        setNominationVotes,
        candidates,
        setCandidates
      }}
    >
      {children}
    </UserVotesContext.Provider>
  );
};

export {UserVotesContext, UserVotesProvider};

